import { motion } from "framer-motion";
import { MaskLines, FadeIn } from "./Reveal";

export const PageHero = ({ eyebrow, title, image, alt, testid }) => (
  <section
    data-testid={testid}
    className="relative min-h-[62vh] md:min-h-[70vh] flex items-end overflow-hidden grain"
  >
    <div className="absolute inset-0 z-0">
      <motion.img
        src={image}
        alt={alt}
        className="w-full h-full object-cover"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 cine-overlay" />
      <div className="absolute inset-0 vignette" />
    </div>
    <div className="relative z-10 max-w-7xl mx-auto w-full px-5 md:px-10 pb-16 md:pb-20 pt-32">
      <FadeIn delay={0.2}>
        <p className="text-bb-gold font-mono2 text-xs uppercase tracking-mega mb-5">
          {eyebrow}
        </p>
      </FadeIn>
      <MaskLines
        className="font-display uppercase text-bb-silver leading-[0.9] text-5xl sm:text-7xl md:text-8xl"
        delay={0.35}
        lines={[<span key="t">{title}</span>]}
      />
    </div>
  </section>
);
